import { __extends } from "tslib";
import React from 'react';
import { translate } from 'react-i18next';
import X from 'wix-ui-icons-common/X';
import _get from 'lodash/get';
import _truncate from 'lodash/truncate';
import classNames from 'classnames';
import withTheme from '../../providers/theme/withTheme';
import s from './MessageNotification.scss';
import withTranslation from '../../providers/translation/withTranslation';
import NotificationX from '../../svgIcons/dist/components/NotificationX';
import CameraIcon from '../../svgIcons/dist/components/cameraIcon';
import FileIcon from '../../svgIcons/dist/components/fileIcon';
var _MessageNotification = /** @class */ (function (_super) {
    __extends(_MessageNotification, _super);
    function _MessageNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickHandler = function () {
            _this.props.onClick();
        };
        _this.onCloseHandler = function (e) {
            if (e) {
                e.stopPropagation();
            }
            _this.props.onClose();
        };
        return _this;
    }
    _MessageNotification.prototype.nonMobileResponsiveHeader = function (isCompactMode, content) {
        var _a = this.props, t = _a.t, avatar = _a.avatar, title = _a.title;
        return (React.createElement("div", { className: s.header },
            avatar && (React.createElement("div", { className: s.avatar, "data-hook": "avatar" }, avatar)),
            React.createElement("div", { className: s.headerContent },
                title && (React.createElement("span", { "data-hook": "title", className: s.title }, title)),
                isCompactMode && (React.createElement("span", { "data-hook": "message", className: s.message }, content))),
            React.createElement("button", { "data-hook": "close-button", className: s.closeButton, onClick: this.onCloseHandler, "aria-label": t('message-notification.close-button.aria-label') },
                React.createElement(X, null))));
    };
    _MessageNotification.prototype.mobileResponsiveHeader = function () {
        return (React.createElement("div", { className: s.responsiveHeader, "data-hook": "title" }, this.props.title));
    };
    _MessageNotification.prototype.render = function () {
        var _a, _b;
        var _c, _d, _e, _f, _g;
        var _h = this.props, t = _h.t, theme = _h.theme, messages = _h.messages, withCallToAction = _h.withCallToAction, mobileResponsive = _h.mobileResponsive, sendersData = _h.sendersData, title = _h.title, isPrivate = _h.isPrivate;
        var message = messages[messages.length - 1];
        var hasPhotoAttachment = (_c = message.data) === null || _c === void 0 ? void 0 : _c.some(function (d) {
            return /image/.test(d.mimeType);
        });
        var hasFileAttachment = (_d = message.data) === null || _d === void 0 ? void 0 : _d.some(function (d) { return !/text/.test(d.mimeType); });
        var hasMultipleMessages = messages.length > 1;
        var isCompactMode = !hasMultipleMessages && !withCallToAction && !mobileResponsive;
        var fontFamily = _get(theme, 'messageNotification.fontFamily');
        var color = _get(theme, 'messageNotification.textColor');
        var borderRadius = _get(theme, 'messageNotification.borderRadius');
        var callToActionColor = _get(theme, 'messageNotification.callToActionColor');
        var senderData = sendersData === null || sendersData === void 0 ? void 0 : sendersData.filter(function (sd) { var _a; return sd.id === ((_a = message.sender) === null || _a === void 0 ? void 0 : _a.userId); }).pop();
        var name = (_g = (_f = (_e = message.senderDisplayData) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : senderData === null || senderData === void 0 ? void 0 : senderData.userName) !== null && _g !== void 0 ? _g : title;
        var content = _truncate(message.summary, { length: 70 });
        return (React.createElement(React.Fragment, null,
            mobileResponsive && (React.createElement("button", { "data-hook": "close-button", className: s.responsiveCloseButton, onClick: this.onCloseHandler, "aria-label": t('message-notification.close-button.aria-label') },
                React.createElement(NotificationX, null))),
            React.createElement("div", { className: classNames(s.wrapper, (_a = {},
                    _a[s.compactMode] = isCompactMode,
                    _a[s.mobileResponsive] = mobileResponsive,
                    _a)), "data-hook": "wrapper", onClick: this.onClickHandler, style: {
                    fontFamily: fontFamily,
                    color: color,
                    borderRadius: !mobileResponsive && borderRadius,
                }, role: "alert", "aria-label": t('message-notification.aria-label') },
                !mobileResponsive &&
                    this.nonMobileResponsiveHeader(isCompactMode, content),
                mobileResponsive && !isPrivate && this.mobileResponsiveHeader(),
                !isCompactMode && (React.createElement("div", { className: s.content, "data-hook": "content" },
                    React.createElement("span", { "data-hook": "message", className: classNames(s.message, (_b = {},
                            _b[s.hasAttachment] = hasFileAttachment,
                            _b)) },
                        mobileResponsive && !!name && (React.createElement("span", { "data-hook": "name", className: s.name },
                            name,
                            ":\u00A0")),
                        mobileResponsive && hasFileAttachment ? (React.createElement("span", { "data-hook": "photo-label", className: s.attachmentLabel },
                            hasPhotoAttachment ? React.createElement(CameraIcon, null) : React.createElement(FileIcon, null),
                            hasPhotoAttachment
                                ? t('message-notification.mobile-responsive-attachment.photo-label')
                                : t('message-notification.mobile-responsive-attachment.file-label'))) : (content)),
                    hasMultipleMessages && (React.createElement("div", { "data-hook": "multiple-messages-indication", className: s.multipleMessagesIndication }, t('message-notification.multiple-messages-indication.text', {
                        numberOfMessages: messages.length - 1,
                    }))),
                    withCallToAction && (React.createElement("button", { "data-hook": "call-to-action", className: s.callToAction, style: { color: callToActionColor } }, t('message-notification.call-to-action.text'))))))));
    };
    _MessageNotification.defaultProps = {
        withCallToAction: false,
    };
    return _MessageNotification;
}(React.Component));
export var MessageNotification = withTheme(withTranslation(translate()(_MessageNotification)));
//# sourceMappingURL=MessageNotification.js.map